export default {
  download: {
    appName: '蓝鲨 App',
    slogan: '智能出行，一手掌握',
    tips1: '蓝鲨App使用设备系统要求',
    tips2: 'Android系统需8.0及以上，iOS系统需12及以上',
    weTips1: '当前环境不支持下载安装',
    weTips2: '1.请选择右上角···使用浏览器打开',
    weTips3: '2.浏览器打开后即可下载安装',
    iosListTitle: '请选择你的国家或地区',
    androidListTitle: '请选择你所使用的App版本',
    ChineseVersion: '中国大陆地区版本',
    InoternationalVersion: '其他国际地区版本',
    asian: '亚太地区',
    european: '欧洲地区'
  },
  support: {
    title: '服务支持',
    productAndService: '产品支持及服务',
    service: '维护保养及服务政策',
    toService: '点击查询产品售后维护保修政策',
    view: '立即查看',
    product: '产品使用手册',
    toProduct: '点击查看及下载产品说明及使用手册',
    chooseModel: '请根据您所购买的产品选择相应的车型',
    rModel: '蓝鲨 R 系列',
    hModel: '蓝鲨 H 系列'
  },
  R1config: {
    battery: '电池',
    capacity: '电池包容量',
    NEDC: 'NEDC 续航',
    powerType: '电芯类型',
    automotive: '汽车级锂电',
    charger: '充电器',
    performance: '性能',
    motor: '电机',
    highSpeedMotor: '高速无刷永磁齿轮电机',
    topSpeed: '最大时速',
    ratedPower: '额定功率',
    peakPower: '峰值功率',
    torque: '扭矩',
    gradability: '爬坡能力',
    turbo: 'Turbo 竞速挡',
    yes: '有',
    no: '无',
    mam: '移车助力档',
    smart: '智能',
    panel: '仪表屏幕',
    IPSScreen: '10" 全彩高清 IPS 屏',
    LCDScreen: '10" 液晶段码屏',
    bluetooth: '蓝牙导航',
    frontalCamera: '前摄像头',
    RearCamera: '后摄像头',
    optional: '选装',
    RAM: '内存',
    viewWhenTurn: '有 (转弯时,显示后方影像)',
    remainRange: '剩余里程',
    bluesharkApp: '蓝鲨 App',
    wireless: '无线连接',
    sensors: '传感器数量 (枚)',
    upgrade: 'OTA 升级',
    safe: '安全',
    smartKey: '蓝牙智能钥匙',
    steeringLock: '电子龙头锁',
    seatLock: '电子座桶锁',
    triMode: '三模定位',
    brake: '刹车',
    CBS: 'CBS 前后联动液压双碟刹',
    ADAS: '防撞预判 (ADAS)',
    remoteAlarm: '远程报警',
    sideStand: '边撑断电',
    virtualVroom: '模拟引擎音',
    light: '灯光',
    autoHeadlight: '感应大灯',
    turnSignal: '转向灯',
    HazardLight: '双闪灯',
    seatLight: '座桶照明灯',
    carpetLight: '氛围地毯灯',
    multimedia: '多媒体',
    speaker: '扬声器',
    HighPowerSpeaker: '大功率扬声器',
    basic: '基础',
    size: '车体尺寸',
    LWH: '(长*宽*高)',
    wheelbase: '轴距',
    tire: '轮胎',
    front: '前',
    rear: '后',
    groundClearance: '离地间隙',
    weight: '裸车重量',
    colors: '车身颜色',
    color: '秋月白 / 云墨黑 / 绿如蓝 / 松涛绿 / 椰林棕'
  },
  H1Product: {
    firstBG: {
      title: '蓝鲨 H1',
      info: '智能电动(轻便)摩托车',
      slogan: '带着热爱，奔涌而来'
    },
    colorName: {
      while: '柔沙白',
      blue: '海盐蓝',
      green: '海藻绿',
      pink: '珊瑚粉',
      black: '礁石黑'
    },
    colorNameSlogan: {
      while: '太阳西沉，微弱的光芒洒在柔软的沙滩上，柔和而宁静',
      blue: '天空与海水融为一体，形成无边无际的宁静蔚蓝',
      green: '如翡翠般闪烁的海草，点缀着海底世界，生意盎然',
      pink: '透明的海水中，绚丽的珊瑚在海流中摇曳生姿，温暖而梦幻',
      black: '浪花汹涌，黑色的岩石伫立在岸边，沉静而神秘'
    },
    performance: {
      title: '性能 以快为先',
      subTitle: '汽车级齿轮减速箱设计及直驱技术，动力传递高效、稳定。',
      maxPower: '最大功率',
      maxSpeed: '最高速度',
      torque: '轮上扭矩',
      climbing: '爬坡能力',
      swerve: '转弯半径'
    },
    gear: {
      title: '矢量算法 驾驶平顺',
      subTitle: '3 种骑行模式，2 种辅助模式',
      model1: '经济模式，节能省电，长效续航',
      model2: '常规模式，城市通勤，平稳输出',
      model3: '运动模式，性能拉满，激情迸发'
    },
    control: {
      title: '精准操控',
      info: '轻松驾驭任何路况'
    },
    battery: {
      title: '安全升级 智能高效',
      info: '蓝鲨动力锂电池 2.0',
      fastCharge: '快速充电',
      largeCapacity: '超大容量',
      endurance: '工况续航',
      highlight1: '更安全',
      highlight2: '更可靠',
      highlightInfo1:
        '优化电芯支架结构，防火阻燃 平面实心铜镀镍极片，抗氧化铜排动力线，降低放电发热',
      highlightInfo2: '激光焊增强稳定性和导电效率',
      highlightInfo3: '新增采集板',
      highlightInfo4: '集成度更高， 连接点连接线减少 50%',
      highlightInfo5: '传感器布置优化'
    },
    cab: {
      title: '蓝鲨智能换电系统',
      slogan: '一站式智能补给，出行一分钟也不耽搁',
      noFeelChange: '无感换电',
      speedSwapping: '极速充电',
      info1: '3 秒换电',
      info2: '仅需两步，即换即走',
      info3: '2h 快速充电',
      info4: '单日可换电 150 次'
    },
    mam: {
      slogan: '一键助力，轻松移车'
    },
    chip: {
      title: '车上的「最强大脑」',
      subTitle1: '动力控制域',
      subTitle2: '系统控制域',
      highDot1: '驱动控制 MCU',
      highDot2: '电池管理 BMS',
      highDot3: '能源分配',
      content1:
        '可通过电门、制动等执行机构感知驾驶者的操作意图，并结合车辆状态和环境状态，自动配置三电系统最佳工作状态，实现驾乘感受和节能效能的双重优化。',
      content2:
        '动力域实时监控动力系统各单元工作状态，最短路径、最实时算力监测系统异常，以第一安全级别保障核心系统安全，从而保障驾乘人员和环境安全。',
      content3: '驾驶的不再是简单的交通工具，而是一种智能设备的延伸。',
      content4:
        '中控系统、车载信息娱乐系统、流媒体及行车数据，通过系统控制域平台主导管理，更高的集成度，更快的反应速度，让骑乘融入生活。'
    },
    os: {
      title: '智能协助 高效出行',
      info1: '新一代智能车机系统 ArkRide OS 2.0',
      info2: '模块化设计，多样体验',
      info3: '4G 加持， OTA 轻松升级',
      content1: '启动速度提升',
      content2: '稳定性提升',
      content3: '指令反馈速度'
    },
    screen: {
      title: '超大屏幕 数据更清晰',
      info:
        '10” 悬浮式高亮高清全彩 IPS 显示屏，自适应亮度调整，强光下依旧清晰可见'
    },
    handlebar: {
      title: '全新手把 玩趣尽在掌握',
      info: '手柄式设计，按键功能合理排布，智能科技触手可及',
      low: '低 频 区',
      middle: '中 频 区',
      high: '高 频 区',
      content: '手边的便利 用过就再也回不去'
    },
    key: {
      title: '以简驭繁<br/>一键启动 无需多余动作',
      info: '蓝牙智能钥匙，用车全程无感操作，告别钥匙的繁琐',
      highDot1: '蓝牙感应解锁',
      highDot2: '手机 App 解锁'
    },
    app: {
      title1: '蓝鲨 App',
      title2: '更智能 更便捷',
      info: '车况信息，一手掌握',
      highDot1: '车辆定位',
      highDot2: '电量统计',
      highDot3: '行驶轨迹',
      highDot4: '里程记录'
    },
    bikeColor: {
      title: '多彩多姿 激情澎湃'
    },
    config: {
      title: '蓝鲨 H1 性能参数',
      c1: '额定功率',
      c2: '电池电量',
      c3: '最高速度',
      c4: '刹车系统',
      c5: '前后碟刹',
      c6: '智能车机系统',
      c7: '最大载重',
      c8: '车重（含电池）',
      c9: '中控仪表',
      c10: '10”全彩高亮高清 IPS 屏',
      c11: '轴距',
      c12: '座高',
      c13: '峰值功率',
      c14: '工况续航',
      c15: '智能中控系统',
      c16: '动力&系统控制域',
      c17: '智能辅助功能',
      c18: '启动方式',
      c19: '蓝牙智能钥匙',
      c21: '配色',
      c22: '转弯半径',
      c23: '尺寸',
      c24: '离地高度'
    }
  },
  iosAsianCountryList: [
    { country: '澳大利亚', url: 'https://apps.apple.com/au/app/id1512077089' },
    { country: '柬埔寨', url: 'https://apps.apple.com/kh/app/id1512077089' },
    { country: '中国', url: 'https://apps.apple.com/cn/app/id1455603928' },
    { country: '香港', url: 'https://apps.apple.com/hk/app/id1512077089' },
    {
      country: '印度尼西亚',
      url: 'https://apps.apple.com/id/app/id1512077089'
    },
    { country: '韩国', url: 'https://apps.apple.com/kr/app/id1512077089' },
    { country: '澳门', url: 'https://apps.apple.com/mo/app/id1512077089' },
    { country: '马来西亚', url: 'https://apps.apple.com/my/app/id1512077089' },
    { country: '菲律宾', url: 'https://apps.apple.com/ph/app/id1512077089' },
    { country: '新加坡', url: 'https://apps.apple.com/sg/app/id1512077089' },
    { country: '台湾', url: 'https://apps.apple.com/tw/app/id1512077089' },
    { country: '泰国', url: 'https://apps.apple.com/th/app/id1512077089' },
    { country: '越南', url: 'https://apps.apple.com/vn/app/id1512077089' }
  ],
  iosEuropeanCountryList: [
    {
      country: '阿尔巴尼亚',
      url: 'https://apps.apple.com/al/app/id1512077089'
    },
    { country: '奥地利', url: 'https://apps.apple.com/at/app/id1512077089' },
    { country: '白俄罗斯', url: 'https://apps.apple.com/by/app/id1512077089' },
    { country: '比利时', url: 'https://apps.apple.com/be/app/id1512077089' },
    {
      country: '波斯尼亚和黑塞哥维那',
      url: 'https://apps.apple.com/ba/app/id1512077089'
    },
    { country: '保加利亚', url: 'https://apps.apple.com/bg/app/id1512077089' },
    { country: '克罗地亚', url: 'https://apps.apple.com/hr/app/id1512077089' },
    {
      country: '捷克共和国',
      url: 'https://apps.apple.com/cz/app/id1512077089'
    },
    { country: '丹麦', url: 'https://apps.apple.com/dk/app/id1512077089' },
    { country: '爱沙尼亚', url: 'https://apps.apple.com/ee/app/id1512077089' },
    { country: '法国', url: 'https://apps.apple.com/fr/app/id1512077089' },
    { country: '芬兰', url: 'https://apps.apple.com/fi/app/id1512077089' },
    { country: '德国', url: 'https://apps.apple.com/de/app/id1512077089' },
    { country: '希腊', url: 'https://apps.apple.com/gr/app/id1512077089' },
    { country: '匈牙利', url: 'https://apps.apple.com/hu/app/id1512077089' },
    { country: '冰岛', url: 'https://apps.apple.com/is/app/id1512077089' },
    { country: '意大利', url: 'https://apps.apple.com/it/app/id1512077089' },
    { country: '爱尔兰', url: 'https://apps.apple.com/ie/app/id1512077089' },
    { country: '拉脱维亚', url: 'https://apps.apple.com/lv/app/id1512077089' },
    { country: '立陶宛', url: 'https://apps.apple.com/lt/app/id1512077089' },
    { country: '卢森堡', url: 'https://apps.apple.com/lu/app/id1512077089' },
    { country: '马耳他', url: 'https://apps.apple.com/mt/app/id1512077089' },
    { country: '摩尔多瓦', url: 'https://apps.apple.com/md/app/id1512077089' },
    { country: '黑山', url: 'https://apps.apple.com/me/app/id1512077089' },
    { country: '荷兰', url: 'https://apps.apple.com/nl/app/id1512077089' },
    { country: '挪威', url: 'https://apps.apple.com/no/app/id1512077089' },
    { country: '波兰', url: 'https://apps.apple.com/pl/app/id1512077089' },
    { country: '葡萄牙', url: 'https://apps.apple.com/pt/app/id1512077089' },
    { country: '罗马尼亚', url: 'https://apps.apple.com/ro/app/id1512077089' },
    { country: '俄罗斯', url: 'https://apps.apple.com/ru/app/id1512077089' },
    { country: '塞尔维亚', url: 'https://apps.apple.com/rs/app/id1512077089' },
    { country: '斯洛伐克', url: 'https://apps.apple.com/sk/app/id1512077089' },
    {
      country: '斯洛文尼亚',
      url: 'https://apps.apple.com/si/app/id1512077089'
    },
    { country: '西班牙', url: 'https://apps.apple.com/es/app/id1512077089' },
    { country: '瑞典', url: 'https://apps.apple.com/se/app/id1512077089' },
    { country: '瑞士', url: 'https://apps.apple.com/ch/app/id1512077089' },
    { country: '乌克兰', url: 'https://apps.apple.com/ua/app/id1512077089' },
    { country: '英国', url: 'https://apps.apple.com/gb/app/id1512077089' }
  ]
}



// WEBPACK FOOTER //
// ./src/i18n/cn.js